import React from "react";
import { Button } from "./ui/button";
import { Phone } from "lucide-react";
import { COMPANY } from "../mock";

export default function CTABanner({ onBookNow }) {
  return (
    <section className="relative py-16 overflow-hidden hero-gradient text-white">
      <div className="absolute inset-0 opacity-20">
        <img
          src="https://images.unsplash.com/photo-1694827893591-af9b80361599?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxODF8MHwxfHNlYXJjaHwzfHxjb3BwZXIlMjBwaXBlc3xlbnwwfHx8fDE3Nzg5MTQ1NDR8MA&ixlib=rb-4.1.0&q=85"
          alt="Copper plumbing background"
          className="w-full h-full object-cover"
        />
      </div>
      <div className="relative max-w-5xl mx-auto px-6 text-center">
        <h2 className="text-3xl md:text-4xl font-extrabold mb-4">
          Need a plumber now? We're on-call 24/7.
        </h2>
        <p className="text-white/85 max-w-2xl mx-auto mb-8">
          Whether it's an emergency burst pipe at 2am or a planned bathroom upgrade, the
          Cheerings team is ready to help — fast, friendly and fully licensed.
        </p>
        <div className="flex flex-wrap justify-center gap-4">
          <Button
            onClick={onBookNow}
            className="bg-sky-500 hover:bg-sky-600 text-white font-bold px-7 py-6 text-base shadow-xl"
          >
            Book Online Now
          </Button>
          <a href={`tel:${COMPANY.phoneLink}`}>
            <Button
              variant="outline"
              className="bg-white text-[#0a4f8a] hover:bg-sky-500 hover:text-white border-white font-bold px-6 py-6 text-base"
            >
              <Phone size={18} className="mr-2" /> Call {COMPANY.phone}
            </Button>
          </a>
        </div>
      </div>
    </section>
  );
}
